export default "__VITE_ASSET__DfUZl$6V__"